module.exports = __webpack_public_path__ + "media/images/pages/logo-white-3131eb1f38b7d7f62b519f19d3cf9177.png";